// extracted by css-extract-rspack-plugin
export default {"cls1":"SplitVerdictPreviewList-cls1_3m5","cls2":"SplitVerdictPreviewList-cls2_8rN SplitVerdictPreviewList-cls1_3m5"};